const noFollowLinks = document.querySelectorAll('.js-nofollow-link');

Array.prototype.forEach.call(noFollowLinks, function(noFollowLink) {
	noFollowLink.addEventListener('click', function() {
		const href = this.getAttribute('href');

		if (href == '#') {
			this.setAttribute('href', this.getAttribute('data-href'));
			this.click();
		}
	});
});
